import { z } from 'zod'

export interface DataCoverageType {
  jurisdiction: string
  kind: string
  numberOfPatents: number
}

export const patentCountResponseSchema = z.object({
  count: z.record(z.string(), z.record(z.string(), z.number())),
})

export type PatentCountResponseType = z.infer<typeof patentCountResponseSchema>
